import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { DarkmodeProvider } from './contexts/dark-mode';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

if (!container) {
  throw Error('Unable to find root element.');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <DarkmodeProvider>
      <App />
    </DarkmodeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
